document.addEventListener('click', async (event)=>{

  const card = event.target.closest('[data-bundle-card]');

  if(!card) return;


  const handle = card.dataset.handle;


  const sectionId = document
    .querySelector('[data-section-id]')
    .dataset.sectionId;


  const response = await fetch(
    `/products/${handle}?section_id=${sectionId}`
  );


  const html = await response.text();


  const parser = new DOMParser();

  const doc = parser.parseFromString(
    html,
    'text/html'
  );


  const newGallery =
    doc.querySelector('#ProductGalleryWrapper');


  const currentGallery =
    document.querySelector('#ProductGalleryWrapper');


  if(newGallery && currentGallery){

    currentGallery.replaceWith(
      newGallery
    );

    document.dispatchEvent(
      new CustomEvent('shopify:section:load')
    );

  }

});